import { ItListItem, MutationdeleteItListItemFileArgs } from 'types/graphql'

import { useMutation } from '@redwoodjs/web'

const DELETE_ITLISTITEM_FILE_MUTATION = gql`
  mutation DeleteItListItemFileMutation($id: Int!, $type: DeletableFile!) {
    deleteItListItemFile(id: $id, type: $type) {
      id
    }
  }
`

export default function useDeleteItListItemFile(
  options: GraphQLMutationHookOptions<
    ItListItem,
    MutationdeleteItListItemFileArgs
  >
) {
  return useMutation<ItListItem, MutationdeleteItListItemFileArgs>(
    DELETE_ITLISTITEM_FILE_MUTATION,
    options
  )
}
